import { Component } from '@angular/core';
import { TimelineMax, Power2, Quad } from 'gsap';
import * as CustomWiggle from '../../../assets/gsap/plugins/CustomWiggle';
import * as CustomBounce from '../../../assets/gsap/plugins/CustomBounce';
import { CbsBasicsComponent } from '../animation-base-classes/cbs-basics.component';
import { IconService } from '../../core/icon.service';
import { params as paramsSocial } from './social.params';
import * as _ from 'lodash';
import * as d3 from 'd3';
import {BasicChartComponent} from '../animation-base-classes/basic-chart.component';

@Component({
  selector: 'app-demo-abn-triptych-line-hor-steps',
  templateUrl: './demo-abn-triptych-line-hor-steps.component.html',
  styleUrls: ['./demo-abn-triptych-line-hor-steps.component.scss']
})

export class DemoAbnTriptychLineHorStepsComponent extends BasicChartComponent {

  private backgroundGroup;
  private slide01Group;
  private slide01ContentGroup;
  private slide02Group;
  private slide02ContentGroup;
  private slide03Group;
  private slide03ContentGroup;
  private fontFamTitle = 'Arial,Helvetica,sans-serif';
  private fontFamText = 'Arial,Helvetica,sans-serif';

  constructor(
    public iconService: IconService,
  ) {
    super(iconService);
    this.paramObject = {
      'social': paramsSocial,
    };
  }

  public async calculateValues() {
    super.calculateValues();
    this.createLineScales(this.data, this.values);
  }

  public async createElements() {

    this.slide01Group = this.host.select('#slide-01');
    this.slide01ContentGroup = this.host.select('#slide-01-content');
    this.slide01ContentGroup.selectAll('*').remove();
    this.drawSlideLineHorSteps(this.slide01ContentGroup, this.values, this.data);

    this.slide02Group = this.host.select('#slide-02');
    this.slide02ContentGroup = this.host.select('#slide-02-content');
    this.slide02ContentGroup.selectAll('*').remove();
    this.drawTextSlideWithTitle(this.slide02ContentGroup, this.values);

    this.slide03Group = this.host.select('#slide-03');
    this.slide03ContentGroup = this.host.select('#slide-03-content');
    this.slide03ContentGroup.selectAll('*').remove();
    this.drawLogoSlide(this.slide03ContentGroup, this.values);
  }

  public async createAnimation(noAnimation: boolean = false) {
    let p = k => this.parameters[k];
    let v = k => this.values[k];

    let main = new TimelineMax({ repeat: -1 });
    if (!noAnimation) {

      let slide01AnimationTotal = new TimelineMax();

      // slide 1

      let stepsAnimation = new TimelineMax();
      this.animateSteps(stepsAnimation, this.values);
      this.animateUnit(stepsAnimation, this.values);
      slide01AnimationTotal.add(stepsAnimation);

      let legendAnimation = new TimelineMax();
      this.animateLegend(legendAnimation, this.values);
      slide01AnimationTotal.add(legendAnimation);

      let linesAnimation = new TimelineMax();
      this.animateNLines(linesAnimation, this.values, this.data);
      slide01AnimationTotal.add(linesAnimation);

      slide01AnimationTotal.duration(this.timings['slide1Animation']);

      let pauseSlide1 = new TimelineMax()
        .set({}, {}, 'positionForStill')
        .set({}, {}, 1)
        .duration(this.timings['pauseSlide1']);
      slide01AnimationTotal.add(pauseSlide1);

      let slide1Animation = new TimelineMax();
      slide1Animation.to(this.slide01Group.node(), 1, { x: -this.values['width'] }, 'startSlide01Animation');
      slide01AnimationTotal.add(slide1Animation);

      main.add(slide01AnimationTotal);

      // slide 2
      let slide02AnimationTotal = new TimelineMax();

      let slide02AnimationText = new TimelineMax();
      this.animateTextSlide2(slide02AnimationText, this.values, this.data);
      slide02AnimationText.duration(this.timings['slide2Animation']);
      slide02AnimationTotal.add(slide02AnimationText);

      let pauseSlide2 = new TimelineMax()
        .set({}, {}, 1)
        .duration(this.timings['pauseSlide2']);
      slide02AnimationTotal.add(pauseSlide2);
      let slide02Animation = new TimelineMax();
      slide02Animation.to(this.slide02Group.node(), 1, { x: -this.values['width'] }, 'startSlide02Animation');
      slide02AnimationTotal.add(slide02Animation);
      main.add(slide02AnimationTotal);

      // slide 3
      let slide03AnimationTotal = new TimelineMax();
      let logoAnimation = new TimelineMax();
      this.animateTextSlide3(logoAnimation);
      logoAnimation.duration(2);
      slide03AnimationTotal.add(logoAnimation);
      let pauseSlide03 = new TimelineMax()
        .set({}, {}, 4);
      slide03AnimationTotal.add(pauseSlide03);
      // let slide03SlideOutAnimation = new TimelineMax();
      // slide03SlideOutAnimation.to(this.slide03Group.node(), 1, { x: -this.values['width'] });
      // slide03AnimationTotal.add(slide03SlideOutAnimation);
      main.add(slide03AnimationTotal);

      main.add(slide03AnimationTotal);

      let pauseAnimation = new TimelineMax()
        .set({}, {}, 1)
        .duration(this.timings['pauseEnd']);
      main.add(pauseAnimation);
    }

    this.animation = main;
    return this.animation;
  }

  public drawLogoSlide(selection, values) {
    this.backgroundLogo(selection, values);
    this.drawSlideLogo(selection, values, null, null, null, 300);
    this.drawWWW(selection, values);
  }

  public backgroundLogo (selection, values) {
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', this.lightenDarkenColor(values['colorScheme']['value'][0], -20))
      .attr('stroke', 'none');
  }

  public drawWWW(selection, values) {
      let line1 = selection.append('text')
        .attr('id', 'website')
        .attr('x', 300)
        .attr('y', 300)
        .attr('fill', '#868686')
        .attr('font-size', 32)
        .attr('text-anchor', 'middle')
        .attr('font-family', this.fontFamText)
        .text('insights.abnamro.nl');
      let line2 = selection.append('text')
        .attr('id', 'twitter')
        .attr('x', 300)
        .attr('y', 350)
        .attr('fill', '#868686')
        .attr('font-size', 32)
        .attr('text-anchor', 'middle')
        .attr('font-family', this.fontFamText)
        .text('@ABNAMROeconomen');
    }

  public drawSlideLineHorSteps(selection, values, data) {
    this.drawHeader(selection, values);
    this.drawLogoBackground(selection, values, true);
    this.drawLogo(selection, values, 'slide1');
    this.drawTitleText1(selection, values, this.fontFamTitle);
    this.drawTitleText2(selection, values, this.fontFamTitle);
    this.drawSteps(selection, values, data);
    this.drawUnitTextSteps(selection, values);
    this.drawXAxisSteps(selection, values, data);
    this.drawXAxisLabels(selection, values);
    this.drawNLines(selection, values, data);
    this.drawSourceText(selection, values);
  }

  public drawTextSlideWithTitle(selection, values) {
    this.drawHeader(selection, values);
    this.drawLogoBackground(selection, values, true);
    this.drawLogo(selection, values, 'slide2');
    this.drawTitleText1(selection, values, this.fontFamTitle);
    this.drawTitleText2(selection, values, this.fontFamTitle);
    this.drawText(selection, values);
    // this.drawSVGIcon(selection, values)
  }

  public drawLogoBackground(selection, values, border?: boolean) {
    let group = selection.append('g')
      .attr('id', `slide1-logo-group-${this.id}`);
    group.append('path')
      // .attr('transform', 'scale(0.7 0.65) translate(670, -1)')
      .attr('transform', 'scale(0.75 0.7) translate(630.2, 23)')
      .attr('fill', values['logoBackgroundColor'])
      .attr('d', 'M34.24982,147.06424,0,112.8126,0.28344,56.779833c0.1559-30.818021,0.32383-56.066839,0.37319-56.108484,0.0493-0.04165,30.59572-0.209735,67.88081-0.373534l67.79107-0.297815,0.27016,7.4580684c0.14858,4.1019366,0.27014,29.7174426,0.27014,56.9233446v49.465277l-33.86545,33.7346c-18.626,18.55402-34.00907,33.73459-34.18458,33.73459-0.17553,0-15.73155-15.41324-34.56896-34.25164z');

    return group;
  }

  public drawLogo(selection, values, id?: string) {
    let gray = '#868686';
    let yellow = '#f3c000';
    let green = '#009286';

    // selection.append('rect').attr('x', 0).attr('y', 0).attr('width', 150).attr('height', 600).attr('fill', 'red');
    // selection.append('rect').attr('x', 450).attr('y', 0).attr('width', 150).attr('height', 600).attr('fill', 'red');
    let idValue = (id ? `${id}-${this.id}` : `${this.id}`);
    // console.log(idValue);
    let outerGroup = selection.append('g')
      .attr('id', `abn-logo-outer-group${idValue}`)
      // .attr('transform', `translate(478.35, -522.5)`);
      .attr('transform', `translate(485.45, -503)`);
    let innerGroup = outerGroup.append('g')
      .attr('id', `abn-logo-inner-group-${idValue}`)
      // .attr('transform', `scale(0.6 0.6)`);
      .attr('transform', `scale(0.6 0.6)`);
    let logoGroup = innerGroup.append('g')
      .attr('id', `abn-logo-top-group-${idValue}`);

    let logo01 = logoGroup.append('path')
      .attr('id', `abn-logo-top01-${idValue}`)
      .attr('class', `abn-logo-top-${idValue} abn-logo-${idValue}`)
      .attr('fill', yellow)
      .attr('d', 'M 133.59092,986.92203 L 64.614963,1055.4871 L 63.793821,1054.6664 L 63.793821,917.12454 L 133.59092,986.10078 L 133.59092,986.92203');

    let logo02 = logoGroup.append('path')
      .attr('id', `abn-logo-top02-${idValue}`)
      .attr('class', `abn-logo-top-${idValue} abn-logo-${idValue}`)
      .attr('fill', green)
      .attr('d', 'M -4.7715608,872.37243 L 133.59092,872.37243 L 133.59092,986.92203 L 64.614963,918.35641 L 64.614963,1055.4871 L -4.7715608,986.92203 L -4.7715608,872.37243');

  }

  public drawSlideLogo(selection, values, id?: string, x?: number, y?: number, w?: number, h?: number) {
    const logoWidth = 783;
    const logoHeight = 219;
    let factor, actualLogoHeight;
    if (w || values['logoWidth']) {
      factor = (w || values['logoWidth']) / logoWidth;
      actualLogoHeight = logoHeight * factor;
      // console.log(`Tilastokeskus logo height: ${logoHeight * factor}`);
    } else if (h || values['logoHeight']) {
      factor = (h || values['logoHeight']) / logoHeight;
      values['logoWidth'] = logoWidth * factor;
      w = logoWidth * factor;
      actualLogoHeight = h || values['logoHeight'];
      // console.log(`Tilastokeskus logo width: ${logoWidth * factor}`);
    } else {
      factor = 1;
      actualLogoHeight = logoHeight;
    }
    // console.log(factor);

    let gray = '#868686';
    let yellow = '#f3c000';
    let green = '#009286';

    // selection.append('rect').attr('x', 0).attr('y', 0).attr('width', 150).attr('height', 600).attr('fill', 'red');
    // selection.append('rect').attr('x', 450).attr('y', 0).attr('width', 150).attr('height', 600).attr('fill', 'red');
    let idValue = (id ? `${id}-${this.id}` : `${this.id}`);
    // console.log(idValue);
    let outerGroup = selection.append('g')
      .attr('id', `abn-logo-outer-group${idValue}`)
      .attr('transform', `translate(${x || values['logoX'] - (w || values['logoWidth']) / 2} ${(y || values['logoY']) - actualLogoHeight / 2})`);
    let innerGroup = outerGroup.append('g')
      .attr('id', `abn-logo-inner-group-${idValue}`)
      .attr('transform', `scale(${factor} ${factor}) translate(-630,-400)`);
    // translate(-21.20744,-12.592442)
    let logoGroup = innerGroup.append('g')
      .attr('id', `abn-logo-top-group-${idValue}`);

    let logo01 = logoGroup.append('path')
      .attr('id', `abn-logo-top01-${idValue}`)
      .attr('class', `abn-logo-top-${idValue} abn-logo-${idValue}`)
      .attr('fill', yellow)
      .attr('d', 'M 133.59092,986.92203 L 64.614963,1055.4871 L 63.793821,1054.6664 L 63.793821,917.12454 L 133.59092,986.10078 L 133.59092,986.92203');

    let logo02 = logoGroup.append('path')
      .attr('id', `abn-logo-top02-${idValue}`)
      .attr('class', `abn-logo-top-${idValue} abn-logo-${idValue}`)
      .attr('fill', green)
      .attr('d', 'M -4.7715608,872.37243 L 133.59092,872.37243 L 133.59092,986.92203 L 64.614963,918.35641 L 64.614963,1055.4871 L -4.7715608,986.92203 L -4.7715608,872.37243');

    let textGroup = innerGroup.append('g')
      .attr('id', `abn-logo-text-group-${idValue}`)
      // .attr('transform', `scale(${factor} ${factor}) translate(42,-750)`);
    // translate(-21.20744,-12.592442)

    let text01 = textGroup.append('path')
      .attr('id', `abn-text-bottom01-${idValue}`)
      .attr('fill', gray)
      .attr('d', 'M 198.46116,963.92977 L 202.56687,946.27508 L 225.96943,946.27508 L 230.07514,963.92977 L 247.72969,963.92977 L 225.96943,884.68954 L 203.79859,884.68954 L 181.62774,963.92977 L 198.46116,963.92977 z M 222.27428,933.95797 L 206.26201,933.95797 L 213.65229,899.4704 L 214.06287,899.4704 L 222.27428,933.95797');

    let text02 = textGroup.append('path')
      .attr('id', `abn-text-bottom02-${idValue}`)
      .attr('fill', gray)
      .attr('d', 'M 278.9331,929.44219 L 288.7868,929.44219 L 293.71366,929.85227 L 297.4088,932.31602 L 299.05109,936.0111 L 299.87222,940.1168 L 299.05109,945.45438 L 296.58766,949.14946 L 293.71366,950.79141 L 290.42909,951.61266 L 278.9331,951.61266 L 278.9331,929.44219 z M 278.9331,896.59602 L 289.19737,896.59602 L 294.12424,897.8279 L 297.4088,901.52298 L 298.64051,906.86055 L 297.81937,911.78751 L 296.17709,914.66133 L 292.89252,916.71446 L 278.9331,916.71446 L 278.9331,896.59602 z M 291.6608,963.92977 L 295.35594,963.92977 L 299.87222,963.10852 L 304.79908,961.87719 L 308.90479,959.41344 L 312.59993,955.71836 L 315.8845,950.38133 L 316.29508,942.58 L 316.29508,936.42172 L 314.65279,931.49477 L 312.18936,927.38907 L 307.67307,924.51524 L 301.51451,922.46211 L 307.67307,920.40954 L 312.18936,916.71446 L 314.65279,911.37688 L 315.06336,905.21805 L 314.65279,897.8279 L 312.18936,892.49032 L 308.49422,887.97399 L 303.56737,885.92142 L 297.81937,884.68954 L 261.68911,884.68954 L 261.68911,963.92977 L 291.6608,963.92977');

    let text03 = textGroup.append('path')
      .attr('id', `abn-text-bottom03-${idValue}`)
      .attr('fill', gray)
      .attr('d', 'M 352.01476,963.92977 L 352.01476,905.62868 L 374.1856,963.92977 L 396.35644,963.92977 L 396.35644,884.68954 L 380.75474,884.68954 L 380.75474,939.70618 L 380.34417,939.70618 L 359.40504,884.68954 L 336.00248,884.68954 L 336.00248,963.92977 L 352.01476,963.92977');

    let text04 = textGroup.append('path')
      .attr('id', `abn-text-bottom04-${idValue}`)
      .attr('fill', gray)
      .attr('d', 'M 423.04357,928.62094 L 433.30784,918.35641 L 423.04357,907.6818 L 411.95815,918.35641 L 423.04357,928.62094');

    let text05 = textGroup.append('path')
      .attr('id', `abn-text-bottom05-${idValue}`)
      .attr('fill', gray)
      .attr('d', 'M 455.47869,963.92977 L 460.40554,946.27508 L 482.98695,946.27508 L 487.09266,963.92977 L 504.74722,963.92977 L 483.39752,884.68954 L 460.81611,884.68954 L 438.64527,963.92977 L 455.47869,963.92977 z M 479.29181,933.95797 L 463.27954,933.95797 L 471.08039,899.4704 L 479.29181,933.95797');

    let text06 = textGroup.append('path')
      .attr('id', `abn-text-bottom06-${idValue}`)
      .attr('fill', gray)
      .attr('d', 'M 535.1295,963.92977 L 535.1295,902.75485 L 535.54007,902.75485 L 550.32063,963.92977 L 566.3329,963.92977 L 581.52404,902.75485 L 581.93461,902.75485 L 581.93461,963.92977 L 597.94689,963.92977 L 597.94689,884.68954 L 572.49147,884.68954 L 558.94263,938.4743 L 558.12148,938.4743 L 545.80435,884.68954 L 519.11721,884.68954 L 519.11721,963.92977 L 535.1295,963.92977');

    let text07 = textGroup.append('path')
      .attr('id', `abn-text-bottom07-${idValue}`)
      .attr('fill', gray)
      .attr('d', 'M 637.36169,896.59602 L 644.75201,896.59602 L 648.44714,897.41727 L 650.91056,899.05977 L 652.55284,901.9336 L 653.37398,906.86055 L 652.55284,911.37688 L 651.32113,914.66133 L 648.85771,917.94579 L 644.75201,919.17766 L 637.36169,919.17766 L 637.36169,896.59602 z M 637.36169,931.08414 L 641.46745,931.08414 L 647.21542,931.49477 L 650.08942,933.54789 L 652.55284,936.0111 L 653.37398,939.70618 L 653.78454,943.81188 L 653.78454,956.53961 L 655.8374,963.92977 L 671.43912,963.92977 L 671.02855,959.41344 L 670.20742,952.84453 L 669.79685,945.45438 L 669.79685,940.52743 L 668.97571,934.77922 L 666.51229,930.67352 L 664.04881,927.38907 L 660.76425,926.15719 L 657.47969,924.92586 L 655.8374,924.92586 L 655.8374,924.51524 L 662.40652,922.05149 L 666.51229,917.94579 L 669.79685,912.19813 L 670.20742,905.21805 L 668.97571,897.8279 L 666.51229,891.66962 L 662.81709,887.56392 L 658.30083,885.10017 L 651.32113,884.68954 L 620.11774,884.68954 L 620.11774,963.92977 L 637.36169,963.92977 L 637.36169,931.08414');

    let text08 = textGroup.append('path')
      .attr('id', `abn-text-bottom08-${idValue}`)
      .attr('fill', gray)
      .attr('d', 'M 715.78083,953.25516 L 710.85393,952.02328 L 707.97994,948.73883 L 705.92709,942.99063 L 705.51652,934.77922 L 705.51652,913.42946 L 705.92709,905.21805 L 707.97994,899.4704 L 710.85393,896.1854 L 715.78083,894.95407 L 720.70767,896.1854 L 723.99223,899.4704 L 725.63452,905.21805 L 726.45565,913.42946 L 726.86622,923.69399 L 726.45565,934.77922 L 725.63452,942.99063 L 723.99223,948.73883 L 720.70767,952.02328 L 715.78083,953.25516 z M 715.78083,965.16164 L 725.22393,964.34039 L 731.79307,961.87719 L 736.71991,957.77149 L 740.41503,952.02328 L 742.05737,946.27508 L 743.28909,939.70618 L 743.28909,908.91313 L 742.05737,901.9336 L 740.41503,896.1854 L 736.71991,890.43774 L 731.79307,886.33204 L 725.22393,883.86829 L 715.78083,883.45821 L 706.74823,883.86829 L 699.76853,886.33204 L 694.84168,890.43774 L 691.9677,896.1854 L 689.50422,901.9336 L 689.09365,908.91313 L 688.27251,916.71446 L 688.27251,931.49477 L 689.09365,939.70618 L 689.50422,946.27508 L 691.9677,952.02328 L 694.84168,957.77149 L 699.76853,961.87719 L 706.74823,964.34039 L 715.78083,965.16164');

  }

  public drawText(selection, values) {
    let singleReturn = /\r\n|\n|\f/g;
    let lines = values['text'].split(singleReturn);
    let rowNumber = lines.length;
    let lineHeight = values['textFontSize'] * values['textLineHeight'];
    let height = rowNumber * lineHeight;
    // let y = values['height'] / 2 - height / 2; // Deze is geschikt voor uitlijnen in het midden
    let y =  values['chartDomainY'] - values['bannerOffset'];
    let text = selection.append('text')
      .attr('x', values['marginLeft'])
      .attr('y', y)
      .attr('dominant-baseline', 'hanging')
      .attr('fill', values['textFontColor'])
      .attr('font-size', values['textFontSize'])
      .attr('font-family', this.fontFamText)
      .attr('text-anchor', 'start');

    _.map(lines, (line, index) => {
      text.append('tspan')
        .attr('id', `text-${index}-slide2-${this.id}`)
        .attr('x', values['marginLeft'])
        .attr('y', y + index * lineHeight)
        .attr('opacity', 1)
        .text(line);
    });
  }

  public drawSourceText (selection, values) {
    if (values['bronText']) {
          let text = selection.append('text')
            .attr('id', `bron-${this.id}`)
            .attr('text-anchor', 'start')
            .attr('x', values['bronTextLeftOffset'])
            .attr('y', values['height'] - values['bronTextBottomOffset'])
            .attr('dy', '0.1em')
            .attr('alignment-baseline', 'middle')
            .attr('fill', values['labelColor'])
            .attr('font-size', values['legendFontSize'] - 12)
            .attr('font-family', values['legendFontFamily'])
            .text(values['bronText']);
        }
  }

  public drawHeader(selection, values) {
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', values['colorScheme']['value'][0])
      .attr('stroke', 'none');
    if (values['bannerHeight'] > 0) {
      selection.append('rect')
        .attr('x', 0)
        .attr('y', values['bannerOffset']) // vaste offset, zou nog in de params kunnen
        .attr('width', values['width'])
        .attr('height', values['bannerHeight'])
        .attr('fill', values['colorScheme']['value'][1])
        .attr('stroke', 'none');
    } else {

    }
  }

  public drawTitleText1(selection, values, font) {
    selection.append('text')
      .attr('x', values['titleOffsetX'])
      .attr('y', values['title1OffsetY'] + values['bannerOffset'])
      .attr('fill', values['titleColor'])
      .attr('font-family', font)
      .attr('font-size', values['titleFontSize'])
      .attr('font-weight', values['titleFontWeight'])
      .text(values['titleText1']);
  }

  public drawTitleText2(selection, values, font) {
    selection.append('text')
      .attr('x', values['titleOffsetX'])
      .attr('y', values['title2OffsetY'] + values['bannerOffset'])
      .attr('fill', values['titleColor'])
      .attr('font-family', font)
      .attr('font-size', values['titleFontSize'])
      .attr('font-weight', values['titleFontWeight'])
      .text(values['titleText2']);
  }


  public animateTextSlide2(timeline, values?, id?) {
    let singleReturn = /\r\n|\n|\f/g;
    let lines = values['text'].split(singleReturn);
    let rowNumber = lines.length;
    let range = _.range(rowNumber);
    let ids = _.map(range, (r) => {
     return `#text-${r}-slide2-${this.id}`
    });

    timeline.staggerFrom(ids, 1, {opacity : 0}, 0.2)
    ;
  }

  public animateTextSlide3(timeline, values?, id?) {
    let idValue = (id ? `${id}-${this.id}` : `${this.id}`);
    // timeline.fromTo(`#logo-top-group-${this.id}`, 1, {opacity : 0}, { opacity: 1 }, 'startSlide3-0');
    timeline.fromTo(`#abn-logo-top-group-${this.id}`, 3, {scale: 5}, {scale: 1, delay: 1}, 'startSlide3-0');
    // timeline.from(`#abn-logo-top-group-${this.id}`, 1, {scaleY : 0, transformOrigin: '0% 50%' }, 'startSlide3-0');
    timeline.from(`#abn-logo-text-group-${this.id}`, 1, {scaleY : 0, transformOrigin: '0% 50%' }, 'startSlide3-1');
    timeline.fromTo(`#website`, 1, { opacity: 0 }, { opacity: 1 }, 'startSlide3-3');
    timeline.fromTo(`#twitter`, 1, { opacity: 0 }, { opacity: 1 }, 'startSlide3-4');
  }
}



// WEBPACK FOOTER //
// ./src/app/animations/demo-abn-triptych-line-hor-steps/demo-abn-triptych-line-hor-steps.component.ts